<template>
  <div class="m-6">
    <h2>Reports (Pro)</h2>
    <div style="background-color: #ffffff">
      Chart:
      <div class="my-chart ct-chart">
        <GChart
          type="SteppedAreaChart"
          :data="chartDataNew"
          :options="chartOptions"
          />
          <GChart
          type="LineChart"
          :data="chartDataNew"
          :options="chartOptions"
          />
          <GChart
          type="TimelineChart"
          :data="chartDataNew"
          :options="chartOptions"
          />
        <!--<GChart
          type="Timeline"
          :data="chartData"
          :options="chartOptions"
          @ready="onChartReady"
          :settings="{ packages: ['corechart', 'table', 'map'] }"
        />-->
      </div>
    </div>
    <div v-if="finishDates && finishDates">
      tasks in commitement :<pre>{{ tasks_in_commitment('HUuFCcDgStS5IuzJdISb7A','GX4vxXk0cuNdBg0BdbcziqOayAw2') }}</pre>
      tasks_in_all_commitments <pre>{{ tasks_in_all_commitments }}</pre>
      all_finishDate_datapoints_done<pre>{{ all_finishDate_datapoints_done }}</pre>
      commitments: <pre>{{ commitments }}</pre>
      chartDataNew: <pre>{{ chartDataNew }}</pre>
      finishDates: <pre>{{ finishDates }}</pre>
      all_finishDate_datapoints: <pre>{{ all_finishDate_datapoints }}</pre>
      chartDataNew: <pre>{{ chartDataNew }}</pre>
      <!--tasks_in_all_commitments:  <pre>{{ tasks_in_all_commitments }}</pre>-->
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import util from '@/util'
import clonedeep from 'lodash.clonedeep';

//import moment from '@/moment-gp'

export default {
  name: "ReportsSubpage",
  data () {
    return {
      /*chartData: [
        ['Director (Year)',  'Rotten Tomatoes', 'IMDB'],
          ['Alfred Hitchcock (1935)', 8.4,         7.9],
          ['Ralph Thomas (1959)',     6.9,         6.5],
          ['Don Sharp (1978)',        6.5,         6.4],
          ['James Hawes (2008)',      4.4,         6.2]
      ],*/
      chartData: null,
      chartOptions: {
        isStacked: true,
        width: "100%",
        height: 400,
        title: 'Remaining hours in commitment',
        vAxis:  { viewWindowMode: "explicit", viewWindow:{ min: 0 } },
        legend: 'right'
        //legend: 'none',
        /*title: 'Line intervals, default',
        curveType: 'function',
        lineWidth: 4,
        intervals: { 'style': 'line' },
        legend: 'none'*/
      },
      data: {}
    }
  },
  computed: {
    goalId() {
      return this.$route.params.goalId;
    },
    /*goal_meta() {
      return this.$models.goalMeta.subscribeNode( this.goalId );
    },*/

    /*commitments_sorted() {
      return this.$models.commitmentMeta.with({ goalId: this.goalId }).getList().asArraySorted().items;
    },*/
    commitments() {
      console.log('commitments', this.$models.commitmentMeta.with({ goalId: this.goalId }).getList().itemsAsArray())
      return this.$models.commitmentMeta.with({ goalId: this.goalId }).getList().itemsAsArray()
    },
    tasks_in_all_commitments() {
      let tasks_in_all_commitments = {}
      this.commitments.forEach(commitment => {
        console.log('tasks_in_all_commitments', commitment.$id, commitment.assignedUserId)
        let tasks_in_commitment = this.tasks_in_commitment(commitment.$id, commitment.assignedUserId)
        if (commitment.assignedUserId ) {
          tasks_in_commitment.forEach(task => {
            tasks_in_all_commitments[task.$id] = task.$state
          })
        }
      })
      return tasks_in_all_commitments
    },
    finishDatesSerialized() {
      return this.$models.commitmentTaskFinishDates.with({ goalId: this.goalId }).subscribeList();
    },

    finishDates() {
      let finishDates = {}
      if (this.finishDatesSerialized.$readyAll) {
        //console.log('finishDates array:',this.finishDatesSerialized.itemsAsArray())
        this.finishDatesSerialized.itemsAsArray().forEach(finishDatesSerializedCommitment => {
          //console.log('finishDates finishDatesSerializedCommitment', finishDatesSerializedCommitment)
          if (finishDatesSerializedCommitment.finishDatesArray) {
            let finishDatesCommitment = JSON.parse(finishDatesSerializedCommitment.finishDatesArray)
            finishDates[finishDatesSerializedCommitment.$id] = {}
            finishDates[finishDatesSerializedCommitment.$id]['commitment'] = finishDatesCommitment[0]

            let nrFinishDatesCommitment = finishDatesCommitment.length
            if (nrFinishDatesCommitment > 2) {
              let lastTaskFinishDate = finishDatesCommitment[2]
              finishDates[finishDatesSerializedCommitment.$id][finishDatesCommitment[1]] = finishDatesCommitment[2]
              for (let i = 3; i < nrFinishDatesCommitment; i = i + 2) {
                finishDates[finishDatesSerializedCommitment.$id][finishDatesCommitment[i]] = lastTaskFinishDate + finishDatesCommitment[i + 1]
                lastTaskFinishDate = lastTaskFinishDate + finishDatesCommitment[i + 1]
              }
            }
          }
        })
        return finishDates
      } else {
        return null
      }
    },

    all_finishDate_datapoints() {
      let all_finishDate_datapoints = []
      if (this.finishDates && this.tasks_in_all_commitments) {
        Object.keys(this.commitments).forEach(index => {
          let commitmentId = this.commitments[index].$id
          console.log('all_finishDate_datapoints', commitmentId, this.commitments[index])
          if (this.finishDates[commitmentId]) {
            console.log('all_finishDate_datapoints', 'OK')
            Object.keys(this.finishDates[commitmentId]).forEach(taskId => {
              console.log('all_finishDate_datapoints task ',  this.finishDates[commitmentId][taskId])
              if (taskId !== 'commitment' && this.tasks_in_all_commitments[taskId] && this.tasks_in_all_commitments[taskId].name) {
                all_finishDate_datapoints.push({
                  commitmentId: commitmentId,
                  taskId: taskId,
                  finishDate: this.finishDates[commitmentId][taskId],
                  name: this.tasks_in_all_commitments[taskId].name,
                  //commitment: this.tasks_in_all_commitments[commitmentId] && this.tasks_in_all_commitments[commitmentId]['items'] ? this.tasks_in_all_commitments[commitmentId]['items'] : null
                  durationRemaining: this.tasks_in_all_commitments[taskId].durationRemaining ? this.tasks_in_all_commitments[taskId].durationRemaining : 0
                  })
              }
            })
          }
        })
      }
      return all_finishDate_datapoints
    },

    all_finishDate_datapoints_done() {
      let all_finishDate_datapoints_done = []
      if (this.tasks_in_all_commitments) {
        //Object.keys(this.commitments).forEach(index => {
          //let commitmentId = this.commitments[index].$id
          //console.log('all_finishDate_datapoints_done', commitmentId, this.tasks_in_all_commitments)
          Object.keys(this.tasks_in_all_commitments).forEach(taskId => {
            let task = this.tasks_in_all_commitments[taskId]
            let commitmentId = task.laneId

            console.log('yay', task, commitmentId,task.name,  task.done)
            if (task.done && task.finishedAt) {
              console.log('all_finishDate_datapoints_done task ', taskId)
              all_finishDate_datapoints_done.push({
                commitmentId: commitmentId,
                taskId: taskId,
                finishDate: Math.round(task.finishedAt / 1000),
                name: task.name || '',
                //commitment: this.tasks_in_all_commitments[commitmentId] && this.tasks_in_all_commitments[commitmentId]['items'] ? this.tasks_in_all_commitments[commitmentId]['items'] : null
                durationRemaining: task.durationDone || 0
                })
            }
          })
      }
      return all_finishDate_datapoints_done
    },
    chartDataNew() {
      let chartDataNew = []
      if (this.finishDates) {
        let commitmentLastValue = {}
        // push all commitment names
        chartDataNew.push(['Time'])

        Object.keys(this.commitments).forEach(index => {
          let commitmentId = this.commitments[index].$id
          chartDataNew[0].push(this.commitments[index].name || 'Unnamed Commitment')
          commitmentLastValue[commitmentId] = 0
          this.all_finishDate_datapoints
            .filter(item => item.commitmentId === commitmentId)
            .forEach(task =>  {
              commitmentLastValue[commitmentId] += task.durationRemaining / 3600
              console.log('commitmentLastValue', this.commitments[index].name, task.taskId, task.durationRemaining, commitmentLastValue[commitmentId])
            })
        })
        let all_datapoints = (clonedeep(this.all_finishDate_datapoints_done).concat(this.all_finishDate_datapoints)).sort(util.sorter.by_finishDate)
        let nrAll_finishDate_datapoints = all_datapoints.length
        for (let i = 0; i < nrAll_finishDate_datapoints; i++) {
          let newDatapoint = [new Date(all_datapoints[i].finishDate * 1000)]
          Object.keys(this.commitments).forEach(index => {
            let commitmentId = this.commitments[index].$id
            if (commitmentId === all_datapoints[i].commitmentId) {
              newDatapoint.push(Math.max(0, commitmentLastValue[commitmentId] - all_datapoints[i].durationRemaining / 3600))
              commitmentLastValue[commitmentId] = Math.max(0, commitmentLastValue[commitmentId]  - all_datapoints[i].durationRemaining / 3600)
            } else {
              newDatapoint.push(commitmentLastValue[commitmentId])
            }
          })
          chartDataNew.push(newDatapoint)
        }
        return chartDataNew
      } else {
        return null
      }
    }
  },
  methods: {
    tasks_in_commitment(commitmentId, assignedUserId) {
      //let tasks_in_commitments = {}
      //this.commitments.forEach(commitment => {
      return this.$models.taskMeta.with({
        goalId: this.goalId,
        uid: assignedUserId,
      })
      .subscribeList()
      .itemsAsArray()
      .filter(item => item.$state && item.$state.laneId === commitmentId)
      //.subscribeQuery({ key: 'commitmentId', value: commitmentId })
      //.filter(item => item.commitmentId === commitmentId)
    }
  },
  components: {
    GChart
  }
};
</script>

<style lang="scss">
// @import "~chartist/dist/scss/chartist";
</style>
